import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {
  parseLocalDate,
  toIsoDateString,
  DATE_INPUT_PLACEHOLDER,
} from "./dateFormat";

/**
 * European date input (DD/MM/YYYY display).
 * Value/onChange use YYYY-MM-DD strings (same as native type="date").
 * onChange receives a synthetic event: { target: { value, name } }.
 */
export default function DateInput({
  value = "",
  onChange,
  className = "form-control",
  disabled = false,
  isInvalid = false,
  placeholder = DATE_INPUT_PLACEHOLDER,
  style,
  name,
  id,
  required = false,
  isClearable,
  ...rest
}) {
  const selected = parseLocalDate(value);

  const handleChange = (date) => {
    if (typeof onChange !== "function") return;
    const iso = date ? toIsoDateString(date) : "";
    onChange({
      target: {
        value: iso,
        name: name || "",
      },
    });
  };

  const clearable = isClearable !== undefined ? isClearable : !required;
  const inputClass = `${className || "form-control"}${isInvalid ? " is-invalid" : ""}`;

  return (
    <DatePicker
      id={id}
      name={name}
      selected={selected}
      onChange={handleChange}
      dateFormat="dd/MM/yyyy"
      placeholderText={placeholder}
      disabled={disabled}
      required={required}
      className={inputClass}
      wrapperClassName="ics-date-input-wrapper"
      calendarStartDay={1}
      showMonthDropdown
      showYearDropdown
      dropdownMode="select"
      withPortal
      isClearable={clearable}
      autoComplete="off"
      style={style}
      {...rest}
    />
  );
}
